import React from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line import/no-unresolved
import logo from 'comune.imola.voltotheme/components/ImolaTheme/Logo/logo.png?width=130';

const Logo = () => {
  const subsite = useSelector((state) => state.subsite?.data);

  if (subsite?.subsite_css_class?.token === 'sportelloedilizia') {
    return null;
  }

  return (
    <figure className="icon">
      <img src={logo} alt="Comune di Imola" width="130" height="181" />
    </figure>
  );
};

export default Logo;
